module.exports = __webpack_public_path__ + "static/img/05.8d5d3042.png";